import emailConfirmLogo from 'assets/img/email-confirm.svg';

export default (theme) => ({
    Content: {
        width: 300,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    Title: {
        fontFamily: theme['$font-heading'],
        fontSize: 18,
        lineHeight: '23px',
        color: theme['$text-color'],
        marginTop: 20,
        fontWeight: 'bold'
    },
    Logo: {
        display: 'inline-block',
        background: 'url(' + emailConfirmLogo + ') no-repeat',
        backgroundSize: 'contain',
        width: 322,
        height: 303
    },
    Text: {
        fontFamily: theme['$font-default'],
        fontSize: 12,
        lineHeight: '17px',
        marginTop: 20,
        textAlign: 'center'
    },
    Button: {
        width: 160,
        marginTop: 20
    },
});
